import { noiseMixin } from 'src/ui/common/atoms/button/button.styles';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledBanner = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 370px;
    margin-top: 144px;

    ${media.sm`
        height: 420px;
    `}
    ${noiseMixin};
`;

export const StyledTitle = styled(Typography)`
    position: relative;
    z-index: 2;
    width: 310px;
    text-align: center;

    ${media.sm`
    width: 482px;
  `}
`;

export const StyledDescription = styled(Typography)`
    position: relative;
    z-index: 2;
    width: 355px;
    padding: 24px 0;
    text-align: center;

    ${media.sm`
    width: 420px;
    padding: 30px 0;
  `}
`;

export const StyledButtonsWrapper = styled.div`
    position: relative;
    z-index: 2;
    display: flex;

    button:last-child {
        margin-left: 12px;
    }
`;

export const StyledCanvas = styled.canvas`
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
`;